import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function Input({
  t,
  type = "text",
  placeHolder,
  errorText,
  id,
  value,
  onChange,
  formatCheck = () => {},
}) {
  const [showError, setShowError] = useState(false);
  const focusIndex = useSelector((state) => state.element.focusIndex);
  const isFocus = useSelector((state) => state.element.isFocus);
  const [isEdit, setIsEdit] = useState(false);
  const focusNameList = useSelector((state) => state.element.focusNameList);
  const theme = useSelector((state) => state.element.theme);

  useEffect(() => {
    if (formatCheck()) {
      setShowError(false);
    } else {
      setShowError(true);
    }
    console.log(
      `[Input] formatCheck: ${formatCheck()}, showError: ${showError}`
    );
  }, [value, formatCheck]);

  function checkFormat(e) {
    if (e) {
      e.preventDefault();
    }
    setShowError(!formatCheck());
  }

  useEffect(() => {
    const element = document.getElementById(id);
    if (element) {
      element.addEventListener("focusout", checkFormat, true);
      return () => {
        element.removeEventListener("focusout", checkFormat, true);
      };
    }
  });

  const selectedItem = () => {
    const idx = focusNameList.findIndex((item) => {
      return item === id;
    });
    if (idx === focusIndex && isFocus) {
      let css = ` border-thin placeholder-${theme}-focus bg-transparent bg-opacity-50 border-[3px] `;
      if (isEdit) {
        return ` ${css} border-red-500 bg-red-800 `;
      } else {
        return ` ${css} border-${theme}-on-focus bg-${theme}-input-focus`;
      }
    }
    if (isEdit) {
      setIsEdit(false);
    }
    return `  border-[1px] border-${theme}-normal bg-transparent placeholder-${theme}-normal`;
  };

  function _onChange(e) {
    setIsEdit(true);
    onChange(e);
  }

  return (
    <>
      <div
        className={`corner-outline flex flex-col  
          hover:border-${theme}-btn-hover hover:bg-${theme}-btn-hover hover:bg-opacity-30 h-[52px] 
          focus:border-[3px] focus:border-${theme}-btn-focus 
          mt-5 rounded-md border-b-[1px] border-${theme}-radio`}
      >
        <span
          className={`corner-b-l-input border-${theme}-radio`}
          aria-hidden="true"
        />
        <span
          className={`corner-b-r-input border-${theme}-radio`}
          aria-hidden="true"
        />
        <input
          className={`rounded-md h-full w-full text-xl px-4 text-[22px] input-text text-${theme}-normal 
          ${showError && "bg-btn-click "} ${selectedItem()}
          `}
          id={id}
          name={id}
          type={type}
          placeholder={placeHolder}
          aria-label={placeHolder}
          aria-roledescription={"input"}
          value={value}
          autoComplete="off"
          onChange={(e) => _onChange(e.target.value)}
          spellCheck="false"
          aria-autocomplete="none"
        />
      </div>
      {showError && (
        <div className={"flex w-full h-[24px] grow-0 mt-2"}>
          <div className={"w-[24px] h-full z-10 grid place-items-center"}>
            <div className={"bg-error bg-contain bg-no-repeat w-full h-full"} />
          </div>
          <p
            className={
              "h-full align-middle grid place-items-center px-2 text-error font-sans"
            }
          >
            {errorText}
          </p>
        </div>
      )}
    </>
  );
}
